import BaseComponent from './BaseComponent';
import Menu from './Menu';

export default class Header extends BaseComponent {
	constructor() {
		super();

		this.init();

		// Listeners
		document.addEventListener('leave', () => {
			this.menu.close();
		});

		document.addEventListener('update-header', () => {
			this.init();
		});
	}

	init() {
		this.stay = false;

		// Elements
		this.elm = document.querySelector('[data-header]');
		this.blur = document.querySelector('[data-header-blur]');
		this.menuButton = this.elm.querySelector('[data-menu-button]');

		this.menu = new Menu(this.elm.querySelector('[data-menu]'), this);

		this.menuButton.addEventListener('click', () => {
			this.menu.toggle();
		});
	}

	showBlur() {
		this.blur.classList.add('show-blur');
		this.stay = true;
	}

	hideBlur() {
		this.blur.classList.remove('show-blur');
		this.stay = false;
	}
}
